export default __webpack_public_path__ + "static/media/lemonsito_350ml.e11d499d.jpeg";